import { isNil } from 'lodash';

const LOAN_TOKEN_PATTERN = /\{(loanId|loanNumber|borrowerId)\}/g;

const resolveTokenValue = (token, ctx) => {
  const value = ctx?.[token];

  if (isNil(value)) {
    return '';
  }

  return String(value);
};

/**
 * Replaces the supported loan tokens (`{loanId}`, `{loanNumber}`,
 * `{borrowerId}`) in an iframe URL with live loan values from `ctx`.
 *
 * Unresolved or unavailable tokens collapse to an empty string — the
 * literal `{token}` is never left in the rendered URL, and a missing
 * value never blocks the iframe from rendering.
 *
 * @param {string} url Admin-configured iframe URL, possibly containing tokens.
 * @param {{ loanId?: string, loanNumber?: string, borrowerId?: string }} ctx Live loan context.
 * @returns {string} The URL with every supported token substituted.
 */
export const substituteLoanTokens = (url, ctx) => {
  if (isNil(url)) {
    return '';
  }

  return String(url).replace(LOAN_TOKEN_PATTERN, token =>
    resolveTokenValue(token.slice(1, -1), ctx),
  );
};
